// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-13U7C","container_multiCity":"container_multiCity-eFA5q"};